export default __webpack_public_path__ + "static/media/manrope.fca742de.ttf";